module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "part03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('strong', [_vm._v("III"), _c('br'), _vm._v("THE RANGERS AND THE REPUBLIC")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentm"
  }, [_c('em', [_vm._v("The white man and the red man cannot dwell in harmony together. Nature forbids it")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_c('em', [_vm._v("President")]), _vm._v(" M. B. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMAR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentm"
  }, [_c('em', [_vm._v("So, the government provided for their protection as best it could with the means at its disposal, graciously permitting the citizens to protect themselves by organizing … ranging companies")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OAH")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MITHWICK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentm"
  }, [_c('em', [_vm._v("The river and its banks now presented every evidence of a total defeat of our savage foe. The bodies of men, women, and children were to be seen on every hand wounded, dying, and dead")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_c('em', [_vm._v("Colonel")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" H. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OORE")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a476794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part03.vue
// module id = 117
// module chunks = 0